import { createContext, useContext } from 'react';
import type { SessionMe } from '@/api/queries/auth';

/**
 * Provided by <RequireAuth> only while a session is loaded. Logged-in components read the
 * session from here (not straight from the query cache), so they can never render without
 * one, e.g. for a moment during logout when the cache is cleared.
 */
export const SessionContext = createContext<SessionMe | null>(null);

export function useSession(): SessionMe {
  const session = useContext(SessionContext);
  if (!session) throw new Error('useSession() used outside <RequireAuth>');
  return session;
}
